import {SvgIcon} from "@mui/material";
import * as React from "react";
import styled from "styled-components";
type directionProp = { rotation?: number; color?: string };
const Svg = styled(SvgIcon)<directionProp>`
  &&{
    ${({ rotation }) => rotation && `transform: rotate(${rotation}deg);`}
    ${({ color }) =>
    color &&
    `path {
      fill: ${color};
      }`}
  width:.84em;
  height:.84em;
  }
`;

const ArrowRightIcon = (props: any) => (
  <Svg {...props}>
    <path
      d="M2.475 24.125c-.4 0-.8-.1-1.1-.4-.6-.6-.6-1.5 0-2.1l9.1-9.1-9.1-9.1c-.6-.6-.6-1.5 0-2.1s1.5-.6 2.1 0l10.1 10.1c.3.3.5.7.5 1.1s-.1.8-.4 1.1l-10.2 10.1c-.3.3-.7.4-1 .4z"
      fill="#fff"
      fillRule="nonzero"
    />
  </Svg>
);
export default ArrowRightIcon;
